var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGrowingDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 450,
    height: 210
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "growing_desktop_svg__a",
    x1: 0.965,
    y1: 0.5,
    x2: -0.02,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#158462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68c181"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7211"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1892",
    fill: "url(#growing_desktop_svg__a)",
    d: "M0 0h449.999v210H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7254"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4001",
    d: "M63.954 198.986a87.48 87.48 0 012.373 11.017H0v-80.034a103.577 103.577 0 0121.876 10.317c30.932 19.327 38.778 47.042 42.078 58.7z",
    fill: "#7cce87"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4002",
    d: "M124.615 172.621A80.034 80.034 0 01126.47 210H66.33a87.48 87.48 0 00-2.373-11.017c-3.3-11.655-11.146-39.37-42.078-58.7A103.577 103.577 0 00.003 129.967V95.794c28.611.532 56.55 1.893 82.534 18.129 30.929 19.328 38.778 47.042 42.078 58.698z",
    fill: "#68c181"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4003",
    d: "M200.435 137.547c8.178 28.887-.372 51.239-11.252 72.453h-62.716a80.034 80.034 0 00-1.855-37.379c-3.3-11.656-11.146-39.37-42.078-58.7C56.55 97.686 28.615 96.326 0 95.794v-44c54.017 18.469 109.625-3.4 158.356 27.051 30.933 19.332 38.779 47.041 42.079 58.702z",
    fill: "#3faf77"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4004",
    d: "M90.466 18.502l.177.072c55.517 21.571 112.989-2.552 163.168 28.8 30.932 19.328 38.778 47.043 42.078 58.7 12.245 43.253-13 71.858-27.438 103.925h-79.268c10.88-21.214 19.43-43.566 11.252-72.453-3.3-11.656-11.146-39.37-42.079-58.7C109.625 48.396 54.017 70.264 0 51.795v-51.8h59.024a112.522 112.522 0 0031.442 18.507z",
    fill: "#209e6e"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4005",
    d: "M361.605 18.502c28.273 19.187 35.692 45.364 38.875 56.605 16 56.5-31.987 88.01-36.265 134.893h-95.764c14.435-32.067 39.683-60.672 27.438-103.925-3.3-11.655-11.146-39.37-42.078-58.7-50.179-31.355-107.651-7.232-163.168-28.8l-.177-.072A112.522 112.522 0 0159.024.003h248.917c17.37 1.968 34.294 6.307 50.461 16.409a98.36 98.36 0 013.203 2.09z",
    fill: "#17936f"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4006",
    d: "M364.215 210c4.278-46.883 52.261-78.39 36.265-134.893-3.183-11.241-10.6-37.418-38.875-56.605-1.042-.706-2.1-1.406-3.2-2.093C342.238 6.309 325.314 1.968 307.944 0H450v210h-85.785z",
    fill: "#158462"
  })))));
}

export default __webpack_public_path__ + "static/media/growing_desktop.132a891fe0ab669647bb9f84f9745756.svg";
export { SvgGrowingDesktop as ReactComponent };